const Button = ({ text, disabled = false }) => {
  return (
    <button
      type="submit"
      disabled={disabled}
      className="bg-blue-900 hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed text-white px-8 py-3 mt-5 text-[1.1em] font-semibold rounded-full"
    >
      {text}
    </button>
  );
};

export default Button